import { Users, Calendar, MessageSquare, TrendingUp } from 'lucide-react'

const stats = [
  { label: 'Leads Hoje', value: '12', icon: Users, change: '+3 vs ontem' },
  { label: 'Agendamentos', value: '8', icon: Calendar, change: '2 pendentes' },
  { label: 'Conversas Ativas', value: '24', icon: MessageSquare, change: 'Tempo médio: 4min' },
  { label: 'Taxa de Conversão', value: '34%', icon: TrendingUp, change: '+2% esta semana' },
]

const recentLeads = [
  { name: 'Maria Silva', cause: 'Trabalhista', status: 'Qualificado', time: '10 min atrás' },
  { name: 'João Santos', cause: 'Família', status: 'Em conversa', time: '25 min atrás' },
  { name: 'Ana Oliveira', cause: 'Contrato', status: 'Agendado', time: '1h atrás' },
  { name: 'Carlos Lima', cause: 'Imobiliário', status: 'Novo', time: '2h atrás' },
]

export default function OverviewPage() {
  return (
    <div className="space-y-8">
      <div>
        <h1 className="font-serif text-2xl font-semibold text-foreground">Visão Geral</h1>
        <p className="mt-1 text-sm text-muted-foreground">Resumo do desempenho hoje</p>
      </div>

      {/* Stats Grid */}
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        {stats.map((stat) => (
          <div key={stat.label} className="rounded-lg border border-border bg-card p-5">
            <div className="flex items-center justify-between">
              <span className="text-sm font-medium text-muted-foreground">{stat.label}</span>
              <stat.icon className="h-5 w-5 text-primary" />
            </div>
            <p className="mt-2 font-serif text-3xl font-semibold text-foreground">{stat.value}</p>
            <p className="mt-1 text-xs text-muted-foreground">{stat.change}</p>
          </div>
        ))}
      </div>

      {/* Recent Leads */}
      <div className="rounded-lg border border-border bg-card">
        <div className="border-b border-border px-5 py-4">
          <h2 className="font-serif text-lg font-semibold text-foreground">Leads Recentes</h2>
        </div>
        <div className="divide-y divide-border">
          {recentLeads.map((lead) => (
            <div key={lead.name} className="flex items-center justify-between px-5 py-4">
              <div>
                <p className="text-sm font-medium text-foreground">{lead.name}</p>
                <p className="text-xs text-muted-foreground">{lead.cause}</p>
              </div>
              <div className="text-right">
                <span className="inline-flex items-center rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary">
                  {lead.status}
                </span>
                <p className="mt-1 text-xs text-muted-foreground">{lead.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}